import React from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  Linking,
  StyleSheet,
  Platform} from "react-native";
import commonStyles from "../../styles/commonStyles";
import AntDesign from "@expo/vector-icons/AntDesign";

import { ITaxDoc } from "../../types/ITaxDoc";
import FormattedText from "../../components/FormattedText";
import OverflowTooltipText from "../../components/OverflowTooltipText";
import * as XLSX from "xlsx";

import * as Sharing from "expo-sharing";
import FontAwesome6 from "@expo/vector-icons/FontAwesome6";
import Toast from "react-native-toast-message";
import { SafeAreaView } from "react-native-safe-area-context";

import * as FileSystem from "expo-file-system/legacy";
import AppText from "../../components/AppText";
import FontAwesome from "@expo/vector-icons/FontAwesome";

type TaxDetailsProps = {
  route: {
    params: {
      tax: ITaxDoc[];
      year: string;
    };
  };
  navigation: {
    goBack: () => void;
  };
};

const K1TotalSummary: React.FC<TaxDetailsProps> = ({ route, navigation }) => {
  const { tax, year }: { tax: ITaxDoc[]; year: string } = route.params;

  tax.forEach((item) => {
    if (!item.endingRecourse) {
      console.log("inside condition ......... ");
      item.endingRecourse = item.endingNonrecourse;
    }
    if (!item.beginningRecourse) {
      item.beginningRecourse = item.beginningNonrecourse;
    }
  });
  console.log("sdjlkasdf ssssssssssssss ", tax);
  const generateExcel = async () => {
    const fileName = "K1 Summery.xlsx";
    // Customize the columns
    const customizedTaxDocs = tax.map((doc, index) => ({
      No: index + 1,
      "Entity Name": doc.entityName,
      "K:Beginning Liability": doc.beginningRecourse,
      "Tax Year": doc.taxYear,
      "K:Ending Liability": doc.endingRecourse,
      "L:Beginning Capital Account": doc.beginningCapitalAccount,
      "L:Capital Contribution": doc.capitalContributions,
      "L:Current Year Net Income": doc.currentYearNetIncome,
      "L:Other Increase": doc.otherIncreases,
      "L:Withdrawals/Distribution": doc.otherWithdrawals,
      "L:Ending Capital Account": doc.endingCapitalAccount,
      "1:Ordinary Business Account": doc.ordinaryBusinessIncome,
      "2:Net Rental Real Estate Income": doc.netRentalRealEstateIncome,
      "Interest Income": doc.interestIncome,
      "64:Ordinary Dividend": doc.ordinaryDividends,
      "8: Net Short-Term Capital Gain": doc.netShortTermCapitalGain,
      "9A: Net Long-Term Capital Gain": doc.netLongTermCapitalGain,
      "10:Net Section 1231 gain (loss)": doc.netSection1231Gain,
      "13H:Other Deductions": doc.otherDeductions,
      "14A:Self Employment Earning/Loss": doc.selfEmploymentEarnings,
      "15:Credits": doc.credits,
      "17:Alternative minimum tax (AMT) items": doc.alternativeMinimumTaxItems,
      "18:Tax Exempt Income and Expenses":
        doc.taxExemptIncomeAndNondeductibleExpenses,
      "20A: Other information": doc.otherInformation}));

    const ws = XLSX.utils.json_to_sheet(customizedTaxDocs);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { type: "base64", bookType: "xlsx" });
    const uri = FileSystem.cacheDirectory + fileName;
    await FileSystem.writeAsStringAsync(uri, wbout, {
      encoding: FileSystem.EncodingType.Base64});

    if (Platform.OS === "ios") {
      await Sharing.shareAsync(uri, {
        mimeType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        dialogTitle: "Share K1s"});
      Toast.show({
        type: "success",
        text1: "File downloaded successfully!"});
    } else {
      const permissions =
        await FileSystem.StorageAccessFramework.requestDirectoryPermissionsAsync();
      if (!permissions.granted) {
        Toast.show({
          type: "error",
          text1: "Permission denied to access the directory."});
        return;
      }

      const fileUri = await FileSystem.StorageAccessFramework.createFileAsync(
        permissions.directoryUri,
        fileName,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );

      try {
        await FileSystem.writeAsStringAsync(fileUri, wbout, {
          encoding: FileSystem.EncodingType.Base64});

        Toast.show({
          type: "success",
          text1: "File downloaded successfully!"});
      } catch (error) {
        Toast.show({
          type: "error",
          text1: "Error saving the file."});
      }
    }
  };
  const getTotalForColumn = (columnName: string): number => {
    let total = 0;
    for (const record of tax) {
      total += (record as unknown as Record<string, number>)[columnName] || 0;
    }
    return total;
  };
  return (
    <SafeAreaView edges={[ "bottom", "left", "right"]} style={[commonStyles.flex1, commonStyles.screenBottomGap]}>
      <View style={commonStyles.container}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"}}
        >
          <TouchableOpacity
            style={commonStyles.subHeaderContainer}
            onPress={() => navigation.goBack()}
            testID="back-button"
          >
            <AntDesign name="left" size={30} color="black" testID="back-icon" />
            <AppText testID="k1-total-summary" style={commonStyles.subHeader}>
              {year}: K1 Total Summary
            </AppText>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={generateExcel}
            testID="download-button"
            style={{ marginRight: 10 }}
          >
                    <FontAwesome name="file-pdf-o" size={30} color="#cb180f"  style={{ marginTop: 3 }}  />

          </TouchableOpacity>
        </View>
        <ScrollView>
          <View
            style={[
              commonStyles.subContainer,
              commonStyles.p14,
              commonStyles.mlar2,
              commonStyles.mt5,
              commonStyles.pt0,
              commonStyles.mb10,
            ]}
          >
            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="k-beginning-liability"
                style={commonStyles.sectionLabel}
                text="K:Beginning Liability"
              />
              <FormattedText
                testID="k-beginning-liability-value"
                value={getTotalForColumn("beginningRecourse")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <AppText
                testID="k-ending-liability"
                style={commonStyles.sectionLabel}
              >
                K:Ending Liability
              </AppText>
              <FormattedText
                testID="k-ending-liability-value"
                value={getTotalForColumn("endingRecourse")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="L-beginning-capital-account"
                style={commonStyles.sectionLabel}
                text="L:Beginning Capital Account"
              />
              <FormattedText
                testID="L-beginning-capital-account-value"
                value={getTotalForColumn("beginningCapitalAccount")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="L-capital-contribution"
                style={commonStyles.sectionLabel}
                text="L:Capital Contribution"
              />
              <FormattedText
                testID="L-capital-contribution-value"
                value={getTotalForColumn("capitalContributions")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="L-current-year-net-income"
                style={commonStyles.sectionLabel}
                text="L:Current Year Net Income"
              />
              <FormattedText
                testID="L-current-year-net-income-value"
                value={getTotalForColumn("currentYearNetIncome")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="L-other-increase"
                style={commonStyles.sectionLabel}
                text="L:Other Increase"
              />
              <FormattedText
                testID="L-other-increase-value"
                value={getTotalForColumn("otherIncreases")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="L-withdrawals-distribution"
                style={commonStyles.sectionLabel}
                text="L:Withdrawals/Distribution"
              />
              <FormattedText
                testID="L-withdrawals-distribution-value"
                value={getTotalForColumn("otherWithdrawals")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="L-ending-capital-account"
                style={commonStyles.sectionLabel}
                text="L:Ending Capital Account"
              />
              <FormattedText
                testID="L-ending-capital-account-value"
                value={getTotalForColumn("endingCapitalAccount")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="1:ordinary-business-account"
                style={commonStyles.sectionLabel}
                text="1:Ordinary Business Account"
              />
              <FormattedText
                testID="1:ordinary-business-account-value"
                value={getTotalForColumn("ordinaryBusinessIncome")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="2:net-rental-real-estate-income"
                style={commonStyles.sectionLabel}
                text="2:Net Rental Real Estate Income"
              />
              <FormattedText
                testID="2:net-rental-real-estate-income-value"
                value={getTotalForColumn("netRentalRealEstateIncome")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <AppText testID="Interest-Income" style={commonStyles.sectionLabel}>
                Interest Income
              </AppText>
              <FormattedText
                testID="Interest-Income-value"
                value={getTotalForColumn("interestIncome")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="64:ordinary-dividend"
                style={commonStyles.sectionLabel}
                text="64:Ordinary Dividend"
              />
              <FormattedText
                testID="64:ordinary-dividend-value"
                value={getTotalForColumn("ordinaryDividends")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="8:net-short-term-capital-gain"
                style={commonStyles.sectionLabel}
                text="8: Net Short-Term Capital Gain"
              />
              <FormattedText
                testID="8:net-short-term-capital-gain-value"
                value={getTotalForColumn("netShortTermCapitalGain")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="9A-net-long-term-capital-gain"
                style={commonStyles.sectionLabel}
                text="9A: Net Long-Term Capital Gain"
              />
              <FormattedText
                testID="9A-net-long-term-capital-gain-value"
                value={getTotalForColumn("netLongTermCapitalGain")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="10:net-section-1231-gain"
                style={commonStyles.sectionLabel}
                text="10:Net Section 1231 gain (loss)"
              />
              <FormattedText
                testID="10:net-section-1231-gain-value"
                value={getTotalForColumn("netSection1231Gain")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="13H:other-deductions"
                style={commonStyles.sectionLabel}
                text="13H:Other Deductions"
              />
              <FormattedText
                testID="13H:other-deductions-value"
                value={getTotalForColumn("otherDeductions")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="14A:self-employment-earning-loss"
                style={commonStyles.sectionLabel}
                text="14A:Self Employment Earning/Loss"
              />
              <FormattedText
                testID="14A:self-employment-earning-loss-value"
                value={getTotalForColumn("selfEmploymentEarnings")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <AppText testID="15:credits" style={commonStyles.sectionLabel}>
                15:Credits
              </AppText>
              <FormattedText
                testID="15:credits-value"
                value={getTotalForColumn("credits")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="17:alternative-minimum-tax-items"
                style={commonStyles.sectionLabel}
                text="17:Alternative minimum tax (AMT) items"
              />
              <FormattedText
                testID="17:alternative-minimum-tax-items-value"
                value={getTotalForColumn("alternativeMinimumTaxItems")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="18:tax-exempt-income-and-expenses"
                style={commonStyles.sectionLabel}
                text="18:Tax Exempt Income and Expenses"
              />
              <FormattedText
                testID="18:tax-exempt-income-and-expenses-value"
                value={getTotalForColumn(
                  "taxExemptIncomeAndNondeductibleExpenses"
                )}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>

            <View style={commonStyles.columnContainer}>
              <OverflowTooltipText
                testID="20A:other-information"
                style={commonStyles.sectionLabel}
                text="20A: Other information"
              />
              <FormattedText
                testID="20A:other-information-value"
                value={getTotalForColumn("otherInformation")}
                type="currency"
                style={commonStyles.valueText}
              />
            </View>
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default K1TotalSummary;
